// Shared parsing for the role-labelled "Utente: … | Mentor: … " history string
// used by both moveRouter.js and intentRouter.js. The role labels come from
// each language's vocab (user_label / mentor_label); parsing accepts the
// labels of EVERY bundled language, so a transcript built in one UI language
// still parses after a language switch mid-session.
import BUNDLE from "./prompts.generated.json";
import { escapeRe } from "./langRegex";

const labels = (key) => [...new Set(Object.values(BUNDLE.vocab).map((v) => v[key]).filter(Boolean))];
const anyOf = (list) => list.map(escapeRe).join("|");

const ROLE_RE = new RegExp(`^(${anyOf([...labels("user_label"), ...labels("mentor_label")])}):\\s*`, "i");
const USER_RE = new RegExp(`^(${anyOf(labels("user_label"))}):`, "i");
const MENTOR_RE = new RegExp(`^(${anyOf(labels("mentor_label"))}):`, "i");

export function segments(chat) {
  return (chat || "").split(" | ").map((s) => s.trim()).filter(Boolean);
}

export function stripRole(seg) {
  return seg.replace(ROLE_RE, "").trim();
}

export const isUserSeg = (seg) => USER_RE.test(seg);
export const isMentorSeg = (seg) => MENTOR_RE.test(seg);

// The user's turns of a history string, role label stripped, oldest first.
export function userTurns(chat) {
  return segments(chat).filter(isUserSeg).map(stripRole);
}
